import { useTranslation } from 'react-i18next';
import { useAuth } from './AuthContext';

/**
 * Shown to an authenticated user whose account is not yet approved (access_status
 * !== 'active') — Access Control Phase 1. Blocks the whole customer surface until
 * an admin approves + links a company + grants features.
 */
export default function PendingApproval() {
  const { t } = useTranslation('common');
  const { user, accessStatus, signOut } = useAuth();
  const suspended = accessStatus === 'suspended';

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
        textAlign: 'center',
      }}
    >
      <div style={{ maxWidth: 440 }}>
        <h1 style={{ fontSize: 22, marginBottom: 12 }}>
          {suspended
            ? t('access.suspendedTitle', { defaultValue: 'Доступ приостановлен' })
            : t('access.pendingTitle', { defaultValue: 'Аккаунт на модерации' })}
        </h1>
        <p style={{ opacity: 0.8, lineHeight: 1.5, marginBottom: 20 }}>
          {suspended
            ? t('access.suspendedBody', {
                defaultValue: 'Доступ к вашему аккаунту приостановлен. Свяжитесь с администратором.',
              })
            : t('access.pendingBody', {
                defaultValue:
                  'Спасибо за регистрацию! Администратор проверит и активирует ваш доступ. Мы сообщим, когда всё будет готово.',
              })}
        </p>
        <p style={{ opacity: 0.5, fontSize: 13, marginBottom: 20 }}>{user?.email}</p>
        <button className="signout" onClick={signOut}>
          {t('nav.signOut', { defaultValue: 'Выйти' })}
        </button>
      </div>
    </div>
  );
}
